import React from 'react';
import styles from './index.module.less';
import cs from 'classnames';
import IconFont from '../../Base/IconFont';
import { Tooltip, TooltipProps } from 'antd';

export interface V2TagProps {
  /**
   * @description 颜色系, 可选[blue, lightBlue, orange, green, cyan, grey, purple, red]
   * @default blue
   */
  color?: 'blue' | 'lightBlue' | 'orange' | 'green' | 'cyan' | 'grey' | 'purple' | 'red' | string; // 避免在一些动态入参的场景中报错，导致部署失败
  /**
   * @description icon，设置这个值后，color就会失效
   */
  icon?: string;
  /**
   * @description 点击事件
   */
  onClick?: (el: any) => void;
  /**
   * @description 额外插入的外层class
   */
  className?: string;
  /**
   * @description 额外插入的外层样式
   */
  style?: React.CSSProperties;
  /**
   * @description ant-tooltip配置，配置后立即开启
   */
  tooltipConfig?: TooltipProps;
  /**
   * @description slot插槽
   */
  children?: any;
}
/**
* @description 便捷文档地址
* @see https://reactpc.lanhanba.net/components/Data/v2tag
*/
const V2Tag: React.FC<V2TagProps> = ({
  children,
  color = 'blue',
  icon,
  onClick,
  className,
  style = {},
  tooltipConfig,
  ...props // 提供给antd部分组件渗透如 mouseEnter等方法
}) => {
  const getCom = () => (
    <span
      {...props}
      className={cs(styles.v2Tag, styles[`v2Tag-${color}`], icon ? styles.v2TagIcon : '', className)}
      onClick={(el) => onClick && onClick(el)}
      style={style}
    >
      {
        icon ? <IconFont
          className={cs(styles.v2DetailCopy, 'v2TagDetailCopy')}
          iconHref={icon}
        /> : children
      }
    </span>
  );
  return (
    tooltipConfig ? (
      <Tooltip {...tooltipConfig}>
        {
          getCom()
        }
      </Tooltip>
    ) : getCom()
  );
};

export default V2Tag;
